function findByText(text, exact = false) {
	const els = document.querySelectorAll('span, p, label, h6, h5, h4, button, .MuiTypography-root')
	for (const el of els) {
		const content = el.textContent.trim().toLowerCase()
		if (exact ? content === text.toLowerCase() : content.includes(text.toLowerCase())) {
			return el
		}
	}
	return null
}

function findByLabel(text) {
	const labels = document.querySelectorAll('label, .MuiFormLabel-root, .MuiInputLabel-root')
	for (const label of labels) {
		if (label.textContent.toLowerCase().includes(text.toLowerCase())) {
			return label.closest('.MuiFormControl-root') || label.closest('.MuiGrid-item') || label.parentElement
		}
	}
	return null
}

const ES = navigator.language?.startsWith('es')

export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'chart-mixed',
		title: ES ? 'Bienvenido a Precios Líderes' : 'Welcome to Leading Prices',
		description: ES
			? 'El Analizador de Precios Líderes compara tus precios con los de la competencia en diferentes oficinas y periodos de tiempo. Configura los filtros, selecciona oficinas y proveedores, y comprueba de un vistazo dónde eres más barato, más caro o estás igualado.'
			: 'The Leading Prices Analyzer compares your prices against competitors across offices and time periods. Configure filters, select offices and providers, then see at a glance where you are cheaper, more expensive, or equal.',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByLabel('Providers') || findByLabel('Categories') || findByLabel('Pick up Office')
			if (el) {
				let parent = el.closest('.MuiGrid-container')
				if (parent?.parentElement) {
					const box = parent.parentElement
					const grids = box.querySelectorAll('.MuiGrid-container')
					if (grids.length >= 2) return box
				}
				return parent
			}
			return null
		},
		icon: 'filter',
		title: ES ? 'Filtros de Búsqueda' : 'Search Filters',
		description: ES
			? 'Configura tu análisis: selecciona un Sitio Principal (obligatorio), oficinas de recogida, sitios, rangos de fechas de reserva y recogida, agrupación por día/semana/mes, categorías, LOR, niveles, proveedores y moneda. Despliega "Mostrar Características" para ACRISS, kilometraje, política de combustible y más.'
			: 'Configure your analysis: select a Main Site (required), pick up offices, sites, booking and pickup date ranges, group by day/week/month, categories, LOR, tiers, providers, and currency. Expand "Show Features" for ACRISS, mileage, fuel policy, and more.',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Min. Price') || findByText('Avg. Price')
			if (el) {
				const toggle = el.closest('.MuiToggleButtonGroup-root') || el.closest('[role="group"]')
				if (toggle?.parentElement?.children?.length >= 2) return toggle.parentElement
				return toggle
			}
			return null
		},
		skipIf: () => !findByText('Min. Price'),
		icon: 'sliders',
		title: ES ? 'Agregación de Precios' : 'Price Aggregation',
		description: ES
			? 'Alterna entre precios Mínimo, Medio y Máximo. Esto cambia el precio mostrado en cada celda de la tabla. Medio está seleccionado por defecto.'
			: 'Toggle between Min, Average, and Max prices. This changes the price shown in every cell of the table. Average is selected by default.',
		example: ES
			? 'Precio Mín. | Precio Medio | Precio Máx.'
			: 'Min. Price | Avg. Price | Max. Price',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Leading Price Table')
			if (el) {
				const paper = el.closest('.MuiPaper-root')
				if (paper) return paper
			}
			const tables = document.querySelectorAll('table')
			for (const t of tables) {
				if (t.querySelector('th') && !t.textContent.includes('no matching records')) {
					return t.closest('.MuiPaper-root') || t
				}
			}
			return null
		},
		skipIf: () => !findByText('Leading Price Table') && !document.querySelector('table th'),
		icon: 'table-cells',
		title: ES ? 'Tabla de Precios Líderes' : 'Leading Price Table',
		description: ES
			? 'La tabla de resultados. La primera columna muestra los nombres de las oficinas (fija a la izquierda). Las columnas siguientes representan fechas o periodos de tiempo según tu selección de Agrupar Por (día, semana o mes). Cada celda compara tu precio con el de un competidor.'
			: 'The results table. The first column shows office names (sticky on the left). Subsequent columns represent dates or time periods depending on your Group By selection (day, week, or month). Each cell compares your price against a competitor.',
	},
	{
		type: 'field',
		findTarget: () => {
			const tables = document.querySelectorAll('table')
			for (const t of tables) {
				const rows = t.querySelectorAll('tbody tr')
				if (rows.length > 0 && !t.textContent.includes('no matching records')) {
					const firstCell = rows[0]?.querySelector('td')
					if (firstCell) return firstCell
				}
			}
			return null
		},
		skipIf: () => {
			const tables = document.querySelectorAll('table')
			for (const t of tables) {
				if (t.querySelector('tbody tr td') && !t.textContent.includes('no matching records')) return false
			}
			return true
		},
		icon: 'building',
		title: ES ? 'Columna de Oficina' : 'Office Column',
		description: ES
			? 'La primera columna muestra los nombres de las oficinas en negrita. Esta columna permanece fija a la izquierda al desplazarte horizontalmente, para que siempre sepas qué oficina estás consultando.'
			: 'The first column displays office names in bold. This column stays fixed on the left when scrolling horizontally, so you always know which office you are looking at.',
	},
	{
		type: 'field',
		findTarget: () => {
			const boxes = document.querySelectorAll('table td [style*="border"], table td .MuiBox-root')
			for (const box of boxes) {
				const style = window.getComputedStyle(box)
				if (style.borderWidth && parseInt(style.borderWidth) >= 2 && style.borderStyle === 'solid') {
					return box
				}
			}
			const cells = document.querySelectorAll('table tbody tr td')
			if (cells.length > 1) return cells[1]
			return null
		},
		skipIf: () => {
			const tables = document.querySelectorAll('table')
			for (const t of tables) {
				if (t.querySelector('tbody tr td') && !t.textContent.includes('no matching records')) return false
			}
			return true
		},
		icon: 'palette',
		title: ES ? 'Celdas de Comparación de Precios' : 'Price Comparison Cells',
		description: ES
			? 'Cada celda de precio está codificada por color. El borde verde indica que eres más barato que el competidor. El borde rojo indica que eres más caro. El borde gris indica precio igualado. Dentro de cada celda se muestra el precio, una flecha direccional y el porcentaje de diferencia.'
			: 'Each price cell is color-coded. Green border means you are cheaper than the competitor. Red border means you are more expensive. Grey border means equal price. Inside each cell you see the price, a directional arrow, and the difference percentage.',
		example: ES
			? 'Mas barato ↓12% | Mas caro ↑8% | Igualado ='
			: '🟢 Cheaper ↓12% | 🔴 More Expensive ↑8% | ⚪ Equal =',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo Listo!' : "You're All Set!",
		description: ES
			? 'Selecciona tus filtros, pulsa Buscar y analiza tu posición competitiva. Usa el selector Mín./Media/Máx. para ver diferentes agregaciones de precios. Las celdas verdes indican dónde lideras — las celdas rojas muestran oportunidades para ajustar precios.'
			: 'Select your filters, hit Search, and analyze your competitive position. Use the Min/Avg/Max toggle to see different price aggregations. Green cells are where you lead — red cells show opportunities to adjust pricing.',
	},
]
